"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextToSpeechServiceClient = void 0;
var TextToSpeechServiceClient_1 = require("./TextToSpeechServiceClient");
Object.defineProperty(exports, "TextToSpeechServiceClient", { enumerable: true, get: function () { return __importDefault(TextToSpeechServiceClient_1).default; } });
//# sourceMappingURL=index.js.map